module.exports = __webpack_public_path__ + "static/img/register_success.9efddbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basic/register_success.png
// module id = VSv4
// module chunks = 0